<template>
  <div
    class="outbox"
    v-loading="listLoading"
    element-loading-text="拼命加载中..."
  >
    <div class="flexBox between">
      <div class="nameBox employeeName">{{ param.employeeName }}</div>
      <div class="flexBox ageBox" style="color: #8299dc">
        <div>{{ param.age }}岁</div>
        <div>{{ param.sex }}</div>
        <!-- <div>{{ birthday }}</div> -->
      </div>
    </div>
    <div class="nameBox">
      <span style="color: #999">{{ status }} </span>
    </div>
    <div class="itemBox">
      <el-form :model="param" :inline="true" class="formInline" size="mini">
        <el-form-item label="人员类别:" class="formItem">
          <span class="contentType"> {{ param.personType || "无" }}</span>
        </el-form-item>
        <el-form-item label="米咖注册认证状态:" class="formItem">
          <span class="contentType"> {{ isAuthentivayion || "无" }}</span>
        </el-form-item>
        <el-form-item label="身份证号:" class="formItem">
          <span class="contentType"> {{ param.documentNumber || "无" }}</span>
        </el-form-item>
        <el-form-item label="人员ID:" class="formItem">
          <span class="contentType"> {{ param.empPk || "无" }}</span>
        </el-form-item>
        <el-form-item label="QHR手机号:" class="formItem">
          <span class="contentType"> {{ param.phone || "无" }}</span>
        </el-form-item>
        <el-form-item label="米咖手机号:" class="formItem">
          <span class="contentType"> {{ param.tel || "无" }}</span>
        </el-form-item>
        <!-- <el-form-item label="QHR银行卡号:" class="formItem">
          <span class="contentType"> {{ param.personType }}</span>
        </el-form-item> -->
        <el-form-item label="米咖银行卡号:" class="formItem">
          <span class="contentType"> {{ param.bankNum || "无" }}</span>
        </el-form-item>
        <el-form-item label="员工编号:" class="formItem">
          <span class="contentType"> {{ param.employeeNumber || "无" }}</span>
        </el-form-item>
        <el-form-item label="联系地址:" class="formItem last">
          <span class="contentType last"> {{ param.address || "无" }}</span>
        </el-form-item>
      </el-form>
    </div>

    <div class="tableBody">
      <div class="title">工作履历</div>
      <el-table
        class="limitManagerTable table-expand"
        style="width: 100%"
        :data="tableData"
        size="small"
        border
        header-row-class-name="table-header"
      >
        <el-table-column
          fixed="left"
          width="50"
          type="index"
          label="#"
          align="center"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="clientId"
          label="项目客户"
          align="center"
        ></el-table-column>
        <el-table-column
          width="89"
          prop="quitCrmStatus"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.quitCrmStatus == 1">在职</div>
            <div v-if="scope.row.quitCrmStatus == 2">离职中</div>
            <div v-if="scope.row.quitCrmStatus == 4">离职</div>
            <div v-if="scope.row.quitCrmStatus == 3">取消离职</div>
          </template>
        </el-table-column>
        <el-table-column
          width="89"
          prop="zhangtaoId"
          label="账套"
          align="center"
        ></el-table-column>
        <el-table-column width="130" label="合同开始日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.enterDate && handleTime(scope.row.enterDate) }}
          </template>
        </el-table-column>
        <el-table-column width="130" label="离职时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.lastWorkDay && handleTime(scope.row.lastWorkDay) }}
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="pensionClassCityId"
          label="缴保城市"
          align="center"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="contractTypeId"
          label="合同类型"
          align="center"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="sentSyncTime"
          label="发起时间"
          align="center"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="syncTime"
          label="签约时间"
          align="center"
        ></el-table-column>
         <el-table-column
          width="230"
          prop="qiyuesuoAccountId"
          label="所属公司"
          align="center"
        ></el-table-column>
        <!-- <el-table-column width="100" prop="system" label="合约" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.requirementsStatus == 1"
              style="color: #18a7ff; cursor: pointer"
              @click="edit(scope.row)"
            >
              查看
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formData.pageSize"
        layout="slot,sizes, total,  prev, pager, next, jumper"
        :total="formData.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import utils from "@/common/js/util.js";
import moment from "moment";

export default {
  props: {
    itemId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      //筛选项参数
      param: {},
      //表单信息
      tableData: [],
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      listLoading: false,
    };
  },
  mounted() {
    this.getData(); //获取终端筛选列表
  },
  methods: {
    //获取终端下拉列表
    getData() {
      this.listLoading = true;
      let params = {
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      this.$http({
        method: "GET",
        url: `/rest/CrmQhrInfoRest/qhrlongPromotionDetail?id=${this.itemId}`,
        params,
      })
        .then((res) => {
          console.log(res.data);
          this.param = res.data.data;
          // this.param.isAuthentivayion = 3;
          this.tableData = res.data.data.detailList.items;
          this.formData.total = res.data.data.detailList.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
          this.listLoading = false;
        });
    },
    //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.Information = false;
      this.getData();
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    //时间戳处理
    handleTime(res) {
      res = moment(res).format("YYYY-MM-DD");
      return res;
    },
  },
  computed: {
    birthday() {
      let res = moment(this.param.birthday).format("YYYY-MM-DD");
      return res;
    },
    status() {
      switch (this.param.quitCrmStatus) {
        case 1:
          return "在职";
        case 2:
          return "离职中";
        case 3:
          return "取消离职";
        case 4:
          return "离职";
      }
    },
    isAuthentivayion() {
      switch (this.param.isAuthentivayion) {
        case 9:
          return "未注册";
        case 0:
          return "注册会员";
        case 1:
          return "身份认证";
        case 2:
          return "实名认证";
        case 3:
          return "银行卡认证";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.flexBox {
  display: flex;
}
.between {
  justify-content: space-between;
  .employeeName {
    color: #333399;
    font-weight: 900;
    font-size: 16px;
    height: 25px;
    line-height: 25px;
  }
}
.ageBox {
  width: 30%;
  align-items: center;
  div {
    flex: 1;
  }
}
.nameBox,
.ageBox {
  padding: 0 20px;
  height: 25px;
  line-height: 25px;
}
.formItem {
  width: 40%;
}

.itemBox {
  background: #fff;
  padding: 10px 20px;
  border-radius: 10px;
}
.tableBody {
  background-color: white;
  margin-top: 15px;
  padding: 20px;
}

.title {
  color: #2e2b78;
  margin-bottom: 20px;
  font-weight: 900;
}
.contentType {
  color: #232323;
}
</style> 
<style  lang="scss">
.QHR_InformationBox .el-dialog__header,
.QHR_InformationBox .el-dialog__body {
  background-color: #f2f2f2;
}

.QHR_InformationBox .el-form-item__label {
  width: 130px;
  text-align: left;
  color: #999;
}
.QHR_InformationBox .last.formItem {
  width: 100%;
  display: flex;
  .el-form-item__content {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/qhr/Information.vue